// Colors
//*** WIP *** Jira task DOGS-547 created to research refactoring obsolete colors from site
export enum Colors {
  AMICA_ORANGE = '#dc8633',
  NEAR_BLACK = '#4a4844',
  BLACK = '#000000',
  BROWN_GREY = '#787162',
  BROWN_GREY_BACKGROUND = '#f1f0ef',
  BURNT_ORANGE = '#be4e03',
  CARD_BORDER_MIST = '#aad1cd',
  CYAN = '#006666',
  DARK_BLUE_GREEN = '#00534c',
  NEAR_BLACK_BLUE_GREEN = '#001f1c',
  DARK_CYAN = '#0d756d',
  DARK_PINE_GREEN = '#1A483F',
  DARK_GREY_ORANGE = '#70695c',
  DARK_TEAL = '#00806c',
  DISABLED_GREY = '#747474',
  DISABLED_GREY_BORDER = '#e2e2e2',
  DISABLED_GREY_BORDER_ALT = '#737373',
  DISABLED_GREY_BACKGROUND = '#f0f0f0',
  DISABLED_GREY_TEXT = '#6b6b6b',
  FAINT_GREEN = '#f4fcf8',
  WARNING_RED = '#c94436',
  GREY = '#948E79',
  JUNIPER = '#007c89',
  KHAKI = '#ded7c3',
  LIGHT_GREEN = '#bce6e1',
  NEAR_LIGHT_GREEN = '#d2ebe9',
  LIGHT_GREY = '#e4e2db',
  LIGHT_GREY_BLUE_MAGENTA = '#f4f4f6',
  LIGHT_GREY_CYAN = '#ebf7f6',
  LIGHT_GREY_ORANGE = '#efebe1',
  LIGHT_GREY_RED = '#fbe7e4',
  LIGHT_GREY_YELLOW = '#f9f8f5',
  LIGHT_MINT = '#f0f9f8',
  LIGHT_RED = '#f6c9c3',
  MEDIUM_GREY_CYAN = '#daf1ef',
  MEDIUM_GRAY = '#707070',
  MODERATE_RED = '#b93f31',
  NEAR_WHITE = '#fbfbfa',
  PINE_GREEN = '#0e7e75',
  PINE_GREEN10 = '#ebf4f4',
  SUCCESS_GREEN = '#1c824f',
  VERY_DARK_CYAN = '#005252',
  WHITE = '#fff',
  FAINT_RED = '#fef7f6',
  LINK_HOVER = '#119c90',
  VERSION_CHIP_BACKGROUND = '#0A8A17',
  API_PS2_CHIP_BACKGROUND = '#008085',
  API_PS5_CHIP_BACKGROUND = '#CA00E0',
  API_OTHER_CHIP_BACKGROUND = '#BD5B00',
  TRANSPARENT = '#00000000'
}

export enum Timing {
  COLOR_TRANSITION = 'cubic-bezier(0.17, 0.67, 0.83, 0.67)'
}

// use this tool to be consistent when creating new filters https://cssfilterconverter.com/
export enum Filters {
  PINE_GREEN = 'brightness(0) saturate(100%) invert(39%) sepia(38%) saturate(796%) hue-rotate(126deg) brightness(94%) contrast(101%)'
}
